import type { ReactNode } from 'react'
import { ErrorBoundary } from '@innolab-trader/error-handling'
import { ThemeProvider } from './theme/ThemeProvider'
import { PersistentLanguageProvider } from './i18n/LanguageProvider'
import { CustomerSupportProvider, ChatbotPanel, useCustomerSupport } from '@innolab-trader/customer-support'
import type { Language } from '@innolab-trader/translations'
import { Toaster } from '@innolab-trader/ui'
import type { ChatbotConfig, TourConfig } from '@innolab-trader/customer-support'

export type AppRootProps = {
  children: ReactNode
  defaultLanguage?: Language
  customerSupport?: {
    chatbotConfig?: ChatbotConfig
    tours?: Record<string, TourConfig>
  }
}

export function AppRoot({ children, defaultLanguage, customerSupport }: AppRootProps) {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <CustomerSupportProvider
          chatbotConfig={customerSupport?.chatbotConfig}
          tours={customerSupport?.tours || {}}
        >
          <PersistentLanguageProvider>
            {children}
            <ChatbotOverlay />
          </PersistentLanguageProvider>
        </CustomerSupportProvider>
        <Toaster position="top-right" richColors />
      </ThemeProvider>
    </ErrorBoundary>
  )
}

function ChatbotOverlay() {
  const cs = useCustomerSupport()
  if (!cs) return null
  return (
    <ChatbotPanel
      isOpen={cs.isChatbotOpen}
      onClose={cs.closeChatbot}
      initialMessage={cs.chatbotMessage}
    />
  )
}
